import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { type NormalizedPost } from '../../types';
import { PinIcon } from '../icons/pin-icon';
import { PostHeaderIcon } from './post-header-icon';
import styles from './post-header-icons.scss';

type Props = {
  post: NormalizedPost;
  className?: string;
  iconClassName?: string;
};

export const PostHeaderIcons = ({ post, className, iconClassName }: Props) => {
  const { t } = useTranslation();

  if (!post.isPinned) {
    return null;
  }

  return (
    <div
      className={classNames(styles.container, className)}
      role="img"
      aria-label={t('post-list-item.aria-label.pinned-post')}
    >
      <PostHeaderIcon IconComponent={PinIcon} className={classNames('pin-icon', iconClassName)} />
    </div>
  );
};
